import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  AntSelect,
  AntTextArea,
  CommonButton,
  DatePicker,
  Input as TextInput,
} from "components";
import dayjs from "dayjs";
import moment from "moment";
import { validation } from "./validation";

function CoupenForm({
  setShow,
  onSubmit,
  loading,
  subscriptionData,
  rowData,
  setRowData,
  couponLoading,
}) {
  const { t } = useTranslation();

  const initialValues = {
    title: rowData?.title || "",
    startDate: rowData?.startDate || undefined,
    endDate: rowData?.endDate || undefined,
    subscriptionId: rowData?.subscriptionId || undefined,
    minDiscount: rowData?.minDiscount || 0,
    maxDiscount: rowData?.maxDiscount || 0,
    description: rowData?.description || "",
    limit: "",
  };

  const onHandleSelect = (e, props) => {
    props.setFieldValue("subscriptionId", e);
    let data = subscriptionData?.find((item) => item?.id === e);
    props.setFieldValue("minDiscount", data?.amount);
    props.setFieldValue("maxDiscount", data?.amount);
  };

  return (
    <>
      <Formik
        initialValues={{ ...initialValues }}
        onSubmit={(val) => {
          let data = { ...val };
          if (Object?.keys(rowData)?.length === 0) {
            data.limit = Number(val.limit);
          } else {
            delete data.limit;
          }
          onSubmit(data);
        }}
        validationSchema={validation(rowData)}
      >
        {(props) => {
          return (
            <Form>
              <Row className="gy-3">
                <Col sm="6">
                  <div className="form-group">
                    <label>{t("text.coupen.title")}</label>
                    <TextInput
                      className="form-control"
                      type="text"
                      name="title"
                      placeholder={t("text.coupen.enterTitle")}
                      setFieldValue={props.handleChange}
                      maxlength={50}
                    />
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="form-group">
                    <label>{t("text.coupen.startDate")}</label>
                    <DatePicker
                      className="form-control"
                      placeholder={t("text.coupen.enterStartDate")}
                      suffixIcon={<em className="icon-calendar" />}
                      setFieldValue={props.handleChange}
                      name="startDate"
                      validation
                      defaultValue={
                        rowData?.startDate === null ||
                        rowData?.startDate === undefined ||
                        rowData?.startDate === ""
                          ? undefined || ""
                          : dayjs(rowData?.startDate)
                      }
                      disabledDate={(current) => {
                        let customDate = moment().format("YYYY-MM-DD");
                        return (
                          current && current < moment(customDate, "YYYY-MM-DD")
                        );
                      }}
                    />
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="form-group">
                    <label>{t("text.coupen.endDate")}</label>
                    <DatePicker
                      className="form-control"
                      placeholder={t("text.coupen.enterEndDate")}
                      suffixIcon={<em className="icon-calendar" />}
                      setFieldValue={props.handleChange}
                      name="endDate"
                      validation
                      defaultValue={
                        rowData?.endDate === null ||
                        rowData?.endDate === undefined ||
                        rowData?.endDate === ""
                          ? undefined || ""
                          : dayjs(rowData?.endDate)
                      }
                      disabled={!props.values.startDate}
                      disabledDate={(current) => {
                        let customDate = moment(props.values.startDate).format(
                          "YYYY-MM-DD"
                        );
                        return (
                          current && current <= moment(customDate, "YYYY-MM-DD")
                        );
                      }}
                    />
                  </div>
                </Col>
                <Col sm="6">
                  <div className="form-group">
                    <label>{t("text.coupen.subscription")}</label>
                    <AntSelect
                      size="medium"
                      extraClassName="form-control"
                      name="subscriptionId"
                      loading={loading}
                      variant="standard"
                      placeholder={t("text.coupen.selectSubscription")}
                      arrayOfData={subscriptionData}
                      callback={(e) => {
                        onHandleSelect(e, props);
                      }}
                      disabled={Object?.keys(rowData)?.length !== 0}
                    />
                  </div>
                </Col>
                <Col sm="6">
                  <div className="form-group">
                    <label>{t("text.coupen.minDiscount")}</label>
                    <TextInput
                      className="form-control"
                      type="text"
                      name="minDiscount"
                      placeholder={t("text.coupen.minDiscount")}
                      setFieldValue={props.handleChange}
                      disabled
                    />
                  </div>
                </Col>
                <Col sm="6">
                  <div className="form-group">
                    <label>{t("text.coupen.maxDiscount")}</label>
                    <TextInput
                      className="form-control"
                      type="text"
                      name="maxDiscount"
                      placeholder={t("text.coupen.maxDiscount")}
                      setFieldValue={props.handleChange}
                      disabled
                    />
                  </div>
                </Col>{" "}
                {Object?.keys(rowData)?.length === 0 && (
                  <Col sm="6">
                    <div className="form-group">
                      <label>{t("text.coupen.limit")}</label>
                      <TextInput
                        className="form-control"
                        type="number"
                        name="limit"
                        min="1"
                        placeholder={t("text.coupen.enterLimit")}
                        setFieldValue={props.handleChange}
                        maxlength={2}
                      />
                    </div>
                  </Col>
                )}
                <Col sm="12">
                  <div className="form-group">
                    <label>{t("text.coupen.description")}</label>
                    <AntTextArea
                      name="description"
                      className="form-control"
                      setFieldValue={props.handleChange}
                      placeholder={t("text.coupen.enterDescription")}
                      maxlength={250}
                    />
                  </div>
                </Col>
              </Row>
              <div className="d-flex align-items-center justify-content-end mt-3">
                <CommonButton
                  type="submit"
                  loading={couponLoading}
                  className="btn btn-primary me-2"
                >
                  {rowData?.id ? t("text.common.update") : t("text.common.add")}
                </CommonButton>

                <Link
                  href="#"
                  onClick={() => {
                    setShow(false);
                    setRowData({});
                  }}
                  className="btn btn-outline-primary"
                >
                  {t("text.common.cancel")}
                </Link>
              </div>
            </Form>
          );
        }}
      </Formik>{" "}
    </>
  );
}

export default CoupenForm;
